import type { updatePerfectHit } from 'actions/perfect-hit';
import type { Reducer } from 'react';

import { ACTIONS } from 'actions/perfect-hit';

interface InitialState {
  [studentClassroomId: string]: { perfectHits: number };
}

type PerfectHitReducer = Reducer<InitialState, ReturnType<typeof updatePerfectHit>>;

const initialState: InitialState = {};

const reducer: PerfectHitReducer = (state = initialState, action) => {
  const { type } = action;

  if (type === ACTIONS.UPDATE_PERFECT_HIT) {
    const { studentClassroomId, perfectHits } = action.payload;

    return {
      [studentClassroomId]: { perfectHits },
    };
  }

  return state;
};

export default reducer;
